import { render } from "./HomeView.vue?vue&type=template&id=f9219ae8&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=f9219ae8&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/changlei/roblox-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9219ae8"]])

export default __exports__